export default __webpack_public_path__ + "media/images/carousel/06-a2fe8bdf758678a455119e11f7652c53.jpg";